import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';

export const FavoriteIcon = styled(FontAwesomeIcon)(({
  theme,
  disabled,
  color,
}) => {
  let finalColor = theme.palette.colors.star;
  if (color) {
    finalColor = theme.palette.colors[color];
  } else if (disabled) {
    finalColor = theme.palette.colors.lower;
  }

  return {
    color: finalColor,
    width: '16px',
    height: '14px',
    marginRight: '8px',
  };
});
